<template>
  <b-form @submit.prevent="guardar">
    <b-form-row>
      <b-form-group class="col-md-6">
        <label for="pricipales_vias_exposicion">
          Principales vías de exposición <span style="color: red">(*)</span>
        </label>
        <b-form-textarea id="pricipales_vias_exposicion"
                         name="pricipales_vias_exposicion"
                         required
                         data-vv-as=" "
                         v-model="selectedSeccion11.pricipales_vias_exposicion"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion11.pricipales_vias_exposicion')"
        />
      </b-form-group>
      <b-form-group class="col-md-6">
        <label for="toxicidad_aguda_oral">
          Toxicidad aguda oral <span style="color: red">(*)</span>
        </label>
        <b-form-textarea id="toxicidad_aguda_oral"
                         name="toxicidad_aguda_oral"
                         required
                         data-vv-as=" "
                         v-model="selectedSeccion11.toxicidad_aguda_oral"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion11.toxicidad_aguda_oral')"
        />
      </b-form-group>
    </b-form-row>
    <b-form-row class="bg-row-gray">
      <b-form-group class="col-md-6">
        <label for="toxicidad_aguda_dermica">
          Toxicidad aguda dérmica <span style="color: red">(*)</span>
        </label>
        <b-form-textarea id="toxicidad_aguda_dermica"
                         name="toxicidad_aguda_dermica"
                         required
                         data-vv-as=" "
                         v-model="selectedSeccion11.toxicidad_aguda_dermica"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion11.proteccion_respiratoria')"
        />
      </b-form-group>
      <b-form-group class="col-md-6">
        <label for="toxicidad_aguda_inhalacion">
          Toxicidad aguda por inhalación <span style="color: red">(*)</span>
        </label>
        <b-form-textarea id="toxicidad_aguda_inhalacion"
                         name="toxicidad_aguda_inhalacion"
                         data-vv-as=" "
                         v-model="selectedSeccion11.toxicidad_aguda_inhalacion"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion11.toxicidad_aguda_inhalacion')"
        />
      </b-form-group>
    </b-form-row>
    <b-form-row>
      <b-form-group class="col-md-6">
        <label for="corrosion_cutanea">
          Corrosión o irritación cutánea <span style="color: red">(*)</span>
        </label>
        <b-form-textarea id="corrosion_cutanea"
                         name="corrosion_cutanea"
                         data-vv-as=" "
                         v-model="selectedSeccion11.corrosion_cutanea"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion11.corrosion_cutanea')"
        />
      </b-form-group>
      <b-form-group class="col-md-6">
        <label for="lesiones_ocular_grave">
          Lesiones o irritación ocular grave <span style="color: red">(*)</span>
        </label>
        <b-form-textarea id="lesiones_ocular_grave"
                         name="lesiones_ocular_grave"
                         data-vv-as=" "
                         v-model="selectedSeccion11.lesiones_ocular_grave"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion11.lesiones_ocular_grave')"
        />
      </b-form-group>
    </b-form-row>
    <b-form-row class="bg-row-gray">
      <b-form-group class="col-md-6">
        <label for="sensib_respiratoria_cutanea">
          Sensibilización respiratoria o cutánea <span style="color: red">(*)</span>
        </label>
        <b-form-textarea id="sensib_respiratoria_cutanea"
                         name="sensib_respiratoria_cutanea"
                         data-vv-as=" "
                         v-model="selectedSeccion11.sensib_respiratoria_cutanea"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion11.sensib_respiratoria_cutanea')"
        />
      </b-form-group>
      <b-form-group class="col-md-6">
        <label for="mutagen_cedulas_germinales">
          Mutagenicidad en células germinales <span style="color: red">(*)</span>
        </label>
        <b-form-textarea id="mutagen_cedulas_germinales"
                         name="mutagen_cedulas_germinales"
                         data-vv-as=" "
                         v-model="selectedSeccion11.mutagen_cedulas_germinales"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion11.mutagen_cedulas_germinales')"
        />
      </b-form-group>
    </b-form-row>
    <b-form-row>
      <b-form-group class="col-md-6">
        <label for="carcinogenicidad">
          Carcinogenicidad <span style="color: red">(*)</span>
        </label>
        <b-form-textarea id="carcinogenicidad"
                         name="carcinogenicidad"
                         data-vv-as=" "
                         v-model="selectedSeccion11.carcinogenicidad"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion11.carcinogenicidad')"
        />
      </b-form-group>
      <b-form-group class="col-md-6">
        <label for="toxicidad_reproduccion">
          Toxicidad para la reproducción <span style="color: red">(*)</span>
        </label>
        <b-form-textarea id="toxicidad_reproduccion"
                         name="toxicidad_reproduccion"
                         data-vv-as=" "
                         v-model="selectedSeccion11.toxicidad_reproduccion"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion11.toxicidad_reproduccion')"
        />
      </b-form-group>
    </b-form-row>
    <b-form-row class="bg-row-gray">
      <b-form-group class="col-md-6">
        <label for="toxicidad_organos_unica">
          Toxicidad específica en determinados órganos - exposición única <span style="color: red">(*)</span>
        </label>
        <b-form-textarea id="toxicidad_organos_unica"
                         name="toxicidad_organos_unica"
                         data-vv-as=" "
                         v-model="selectedSeccion11.toxicidad_organos_unica"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion11.toxicidad_organos_unica')"
        />
      </b-form-group>
      <b-form-group class="col-md-6">
        <label for="toxicidad_organos_repetidas">
          Toxicidad específica en determinados órganos - exposiciones repetidas <span style="color: red">(*)</span>
        </label>
        <b-form-textarea id="toxicidad_organos_repetidas"
                         name="toxicidad_organos_repetidas"
                         data-vv-as=" "
                         v-model="selectedSeccion11.toxicidad_organos_repetidas"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion11.toxicidad_organos_repetidas')"
        />
      </b-form-group>
    </b-form-row>
    <b-form-row>
      <b-form-group class="col-md-6">
        <label for="peligro_aspiracion">
          Peligro por aspiración <span style="color: red">(*)</span>
        </label>
        <b-form-textarea id="peligro_aspiracion"
                         name="peligro_aspiracion"
                         data-vv-as=" "
                         v-model="selectedSeccion11.peligro_aspiracion"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion11.peligro_aspiracion')"
        />
      </b-form-group>
      <b-form-group class="col-md-6">
        <label for="informacion_adicional">
          Información adicional <span style="color: red">(*)</span>
        </label>
        <b-form-textarea id="informacion_adicional"
                         name="informacion_adicional"
                         data-vv-as=" "
                         v-model="selectedSeccion11.informacion_adicional"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion11.informacion_adicional')"
        />
      </b-form-group>
    </b-form-row>

    <!-- Modal CAS -->
    <b-modal id="cas-iarc-modal"
             title="Carcinogenicidad"
             size="lg"
             @show="getCarcinogenicidad()"
    >
      <ModalCarcinogenicidad />

      <template #modal-footer="{ ok, cancel, hide }">
        <b-button size="sm" variant="primary" v-b-modal="'cas-sugerencias'">
          Ver sugerencias
        </b-button>
        <b-button size="sm" variant="danger" @click="cancel()">
          Cerrar
        </b-button>
      </template>
    </b-modal>

    <!-- Modal Toxicidades -->
    <b-modal id="toxicidades-modal"
             title="Toxicidades"
             size="lg"
             @show="getToxicidades()"
    >
      <ModalToxicidades />
    </b-modal>

    <hr>
    <FooterButtons back="/fds/listar" :buttons="footerButtons" />
  </b-form>
</template>

<script>
import Swal from 'sweetalert2';
import {mapActions, mapMutations, mapState} from 'vuex';
import FooterButtons from '../../componentes/FooterButtons';
import ModalCarcinogenicidad from "./ModalCarcinogenicidad";
import ModalToxicidades from "@/views/fds/productos/componentes/ModalToxicidades.vue";

export default {
  name: "FDS-Seccion11",
  components: {
    ModalCarcinogenicidad,
    ModalToxicidades,
    FooterButtons
  },
  data() {
    return {
      footerButtons: [
        {
          key: 'btonModalCasIarc',
          variant: 'primary',
          class: 'fa fa-list fa-lg',
          type: 'modal',
          text: 'IARC',
          ref: 'cas-iarc-modal',
        },
        {
          key: 'btonModalToxicidades',
          variant: 'primary',
          class: 'fa fa-flask fa-lg',
          type: 'modal',
          text: 'Toxicidades',
          ref: 'toxicidades-modal',
        },
      ]
    }
  },
  async created() {
    await this.setSeccionActual(11);
    let id_empresa = await this.obtenerIdEmpresaUsuario();
    await this.setIdEmpresaFdsProducto(id_empresa);
    if (this.$route.params.id_fds_producto !== undefined) {
      let id_fds_producto = this.$route.params.id_fds_producto;
      let data = {
        id_empresa: id_empresa,
        id_fds_producto: id_fds_producto,
      };
      await this.getSeccion(data);
      await this.setIdFdsProductoSeccion(id_fds_producto);
      await this.setTipoPeligro('IARC');
      await this.setTipoToxicidad('toxicidad');
    } else {
      await this.resetSeccion();
    }
  },
  methods: {
    async guardar() {
      if (this.accion === 'crear') {
        await this.crearSeccion();
      } else if (this.accion === 'editar'){
        await this.actualizarSeccion();
      }
    },
    ...mapMutations('fds_productos', [
      'setSeccionActual',
      'setIdFdsProductoSeccion',
      'setTipoPeligro',
      'setTipoToxicidad',
    ]),
    ...mapActions('dashboard', [
      'obtenerIdEmpresaUsuario',
    ]),
    ...mapActions('fds_productos', [
      'getSeccion',
      'crearSeccion',
      'actualizarSeccion',
      'getCarcinogenicidad',
      'getToxicidades',
    ]),
    ...mapMutations('fds_productos',[
      'setIdEmpresaFdsProducto',
      'setSeccionActual',
      'resetSeccion',
    ]),
  },
  computed: {
    ...mapState('fds_productos',[
      'id_empresa',
      'accion',
      'selectedSeccion11',
      'tipo_toxicidad'
    ])
  }
}
</script>
<style scoped>
.bg-row-gray {
  background-color: #f0f3f5 !important;
  margin-top: 0.5em !important;
  padding-top: 0.5em !important;
  margin-bottom: 0.5em !important;
  padding-bottom: 0.5em !important;
}
</style>
